/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelSummary } from './HotelSummary';
import {
    HotelSummaryFromJSON,
    HotelSummaryFromJSONTyped,
    HotelSummaryToJSON,
    HotelSummaryToJSONTyped,
} from './HotelSummary';
import type { SearchRequestV2 } from './SearchRequestV2';
import {
    SearchRequestV2FromJSON,
    SearchRequestV2FromJSONTyped,
    SearchRequestV2ToJSON,
    SearchRequestV2ToJSONTyped,
} from './SearchRequestV2';
import type { SuggestedSearchType } from './SuggestedSearchType';
import {
    SuggestedSearchTypeFromJSON,
    SuggestedSearchTypeFromJSONTyped,
    SuggestedSearchTypeToJSON,
    SuggestedSearchTypeToJSONTyped,
} from './SuggestedSearchType';
import type { SearchRequestV3 } from './SearchRequestV3';
import {
    SearchRequestV3FromJSON,
    SearchRequestV3FromJSONTyped,
    SearchRequestV3ToJSON,
    SearchRequestV3ToJSONTyped,
} from './SearchRequestV3';

/**
 * 
 * @export
 * @interface SuggestedSearch
 */
export interface SuggestedSearch {
    /**
     * Unique identifier for the suggested search
     * @type {string}
     * @memberof SuggestedSearch
     */
    id: string;
    /**
     * 
     * @type {SuggestedSearchType}
     * @memberof SuggestedSearch
     */
    type: SuggestedSearchType;
    /**
     * 
     * @type {string}
     * @memberof SuggestedSearch
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof SuggestedSearch
     */
    description: string;
    /**
     * 
     * @type {SearchRequestV3}
     * @memberof SuggestedSearch
     */
    v3Request?: SearchRequestV3;
    /**
     * 
     * @type {SearchRequestV2}
     * @memberof SuggestedSearch
     */
    v2Request?: SearchRequestV2;
    /**
     * 
     * @type {Array<HotelSummary>}
     * @memberof SuggestedSearch
     */
    topResults: Array<HotelSummary>;
    /**
     * The time when the results expire in iso8601 format
     * @type {string}
     * @memberof SuggestedSearch
     */
    resultsExpireAt: string;
}



/**
 * Check if a given object implements the SuggestedSearch interface.
 */
export function instanceOfSuggestedSearch(value: object): value is SuggestedSearch {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('topResults' in value) || value['topResults'] === undefined) return false;
    if (!('resultsExpireAt' in value) || value['resultsExpireAt'] === undefined) return false;
    return true;
}

export function SuggestedSearchFromJSON(json: any): SuggestedSearch {
    return SuggestedSearchFromJSONTyped(json, false);
}

export function SuggestedSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuggestedSearch {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': SuggestedSearchTypeFromJSON(json['type']),
        'title': json['title'],
        'description': json['description'],
        'v3Request': json['v3_request'] == null ? undefined : SearchRequestV3FromJSON(json['v3_request']),
        'v2Request': json['v2_request'] == null ? undefined : SearchRequestV2FromJSON(json['v2_request']),
        'topResults': ((json['top_results'] as Array<any>).map(HotelSummaryFromJSON)),
        'resultsExpireAt': json['results_expire_at'],
    };
}

export function SuggestedSearchToJSON(json: any): SuggestedSearch {
    return SuggestedSearchToJSONTyped(json, false);
}

export function SuggestedSearchToJSONTyped(value?: SuggestedSearch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': SuggestedSearchTypeToJSON(value['type']),
        'title': value['title'],
        'description': value['description'],
        'v3_request': SearchRequestV3ToJSON(value['v3Request']),
        'v2_request': SearchRequestV2ToJSON(value['v2Request']),
        'top_results': ((value['topResults'] as Array<any>).map(HotelSummaryToJSON)),
        'results_expire_at': value['resultsExpireAt'],
    };
}

